export function formatFormPhone(prev = '', next = '') {
  return /(^\d{3}$)|(^\d{3}-\d{3}$)/g.test(next) && prev.length < next.length ? `${next}-` : next;
}
